/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Tab, Table, Tabs, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CommonApiService from '../../../services/CommonApiService';
import { useD1Form } from './ContextAPI';
import ShowTable from './ShowTable';
import Loader from '../../Loader';
import { convertArrayOfObjectsToCSVd1 } from '../../../Utils';
import { useAuth } from '../../../contexts/AuthContext';

const search_column = {
    drug_name: 'Item Names',
    requested_qty: 'Requested Qty',
    approved_request_qty: 'Approved Requested Qty',
};

export default function ShowModel() {
    const { auth } = useAuth();
    const { showModal, setShowModal, rowData, modalLoading } = useD1Form();
    const { drugCategory, getDrugCategory, getFacility, facility } = CommonApiService();

    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    const dataList = useCallback(() => {
        getDrugCategory(); //  Drug Category
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const facilityList = useCallback(() => {
        getFacility(); //  all facility
    }, []);

    // console.log(`facility`, rowData, facility);

    useEffect(() => {
        facilityList();
    }, [facilityList]);

    // Closing the Model
    const handleClose = () => {
        setShowModal(false);
    };

    // eslint-disable-next-line react/no-unstable-nested-components
    function Export({ onClick }) {
        return (
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-download-d1">Download</Tooltip>}>
                <Button
                    className="btn btn-light downloadCsvBtn"
                    onClick={(e) => onClick(e.target.value)}
                >
                    <i className="fa fa-download" />
                </Button>
            </OverlayTrigger>
        );
    }

    function downloadCSV() {
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSVd1(
            search_column,
            rowData,
            auth?.employee_info?.partner_name,
            drugCategory
        );

        if (csv == null) return;
        const filename = `d1 - ${auth?.employee_info?.partner_name} - ${rowData?.facility_name}.csv`;
        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    const tableDataDisplay = () =>
        drugCategory?.map((item, index) => (
            <Tab key={item.id} eventKey={index} title={item.name}>
                <ShowTable
                    data={rowData?.records?.filter((el) => el.category_id == item.id)}
                    allData={rowData?.records}
                    allcategory={drugCategory}
                    rowData={rowData}
                    partner={facility?.filter((el) => el.name == rowData?.facility_name)}
                />
            </Tab>
        ));
    return (
        <Modal className="modalWidth80" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Facility Internal Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modalLoading || !rowData?.records ? (
                    <Loader />
                ) : (
                    <Form>
                    <Row>
                        <Col>
                            <Col className="mb-4 text-end downloadCSV">
                                <Export onClick={() => downloadCSV()} />
                            </Col>
                            <Table bordered hover size="sm">
                                <thead className="table-light">
                                    <tr>
                                        <th>Facility Name </th>
                                        <th>Month</th>
                                        <th>Year</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{rowData?.facility_name}</td>
                                        <td>
                                            {rowData?.month == 1
                                                ? 'January'
                                                : rowData?.month == 2
                                                    ? 'February'
                                                    : rowData?.month == 3
                                                        ? 'March'
                                                        : rowData?.month == 4
                                                            ? 'April'
                                                            : rowData?.month == 5
                                                                ? 'May'
                                                                : rowData?.month == 6
                                                                    ? 'June'
                                                                    : rowData?.month == 7
                                                                        ? 'July'
                                                                        : rowData?.month == 8
                                                                            ? 'August'
                                                                            : rowData?.month == 9
                                                                                ? 'September'
                                                                                : rowData?.month == 10
                                                                                    ? 'October'
                                                                                    : rowData?.month == 11
                                                                                        ? 'November'
                                                                                        : rowData?.month == 12
                                                                                            ? 'December'
                                                                                            : ''}
                                        </td>
                                        <td>{rowData?.year}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Row>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button
                            // className="btnInfo me-2 ms-2"
                            variant="primary"
                            style={{ minWidth: '6rem' }}
                            disabled={page === 0}
                            className={`btnInfo ${page === 0 && 'd-none'}`}
                            onClick={() => {
                                setPage((currPage) => currPage - 1);
                            }}
                        >
                            {page == 0} Prev
                        </Button>
                        <Button
                            type="button"
                            className={`btnSuccess ${page === pageLength - 1 && 'd-none'}`}
                            disabled={page === pageLength}
                            variant="success"
                            style={{ minWidth: '6rem' }}
                            onClick={() => setPage((currPage) => currPage + 1)}
                        >
                            Next
                        </Button>
                    </Modal.Footer>
                    </Form>
                )}
            </Modal.Body>
        </Modal>
    );
}
